// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js","755":"polyfills-css-shim"}[chunkId] || chunkId) + "." + {"278":"36710a76","329":"fa237ddd","603":"e8d2c905","755":"6e12a458"}[chunkId] + ".chunk.js";
};